import { format } from "date-fns";

// export const formatDate = (date, dateFormat = "dd-MM-yyyy") =>
//   date ? format(new Date(date), dateFormat) : "";

export const formatDateTime = (date, dateFormat = "dd MMM yyyy") =>
  date ? format(new Date(date), dateFormat) : "";
